import './searchThirdStep.scss'
import React, { useEffect, useState } from 'react'
import { Button, Container, Grid } from '@material-ui/core'
import { Search, Check } from '@material-ui/icons'
import CheckIcon from '../../assets/Images/check.png'
import Three from '../../assets/Images/three.png'

const { REACT_APP_STRAPI_API_URL } = process.env

function SearchThirdStep() {
  const [usBetters, setUsBetter] = useState()
  const getUsBetterData = async () => {
    const response = await fetch(
      `${REACT_APP_STRAPI_API_URL}/api/us-betters?populate=Image`
    ).then(response => response.json())
    setUsBetter(response?.data)
  }
  useEffect(() => {
    getUsBetterData()
  }, [])

  const [searchDomainTitle, setSearchDomainTitle] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/search-domain-titles`
        )
        const json = await response.json()
        setSearchDomainTitle(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  const [buttons, setButton] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${REACT_APP_STRAPI_API_URL}/api/button-apis`
        )
        const json = await response.json()
        setButton(json?.data[0]?.attributes)
      } catch (error) {}
    }
    fetchData()
  }, [])

  return (
    <>
      <div class="borderboxwrap">
        <div class="title-col1">
          <h1>{searchDomainTitle?.title}</h1>
        </div>
        <form class="searchcolwrap">
          <input type="search" name="search" placeholder="Search" />
          <Button class="btnstyle">
            <Search />
            {buttons?.avax}
          </Button>
        </form>
        <section className="register">
          <Container>
            <Grid item xs={12}>
              <h1>{searchDomainTitle?.ProgressTitle}</h1>
            </Grid>
            <div className="finishprocess">
              <h4>Click register to finish process {'>'}</h4>
              <Button class="btnstyle2">
                <a href="/transferData">
                  <Check />
                  {buttons?.now}
                </a>
              </Button>
            </div>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div className="circlecenter">
                    <img src={CheckIcon} alt=" " class="img-fluid" />
                    <h4>Start to register</h4>
                    <p>
                      Your wallet will open and you will be asked to confirm the
                      first of two transactions required for registration. If
                      the second transaction is not processed within 24 hours of
                      the first, you will need to start again from step 1.
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div className="circlecenter">
                    <img src={CheckIcon} alt=" " class="img-fluid" />
                    <h4>Wait One Minute</h4>
                    <p>
                      The waiting period is required to ensure another person
                      hasn't tried to register the same name and protect you
                      after your request.
                    </p>
                  </div>
                </div>
              </Grid>
              <Grid container item xl={4} lg={4} md={4} sm={12} xs={12}>
                <div className="registerCard">
                  <div className="circlecenter">
                    <img src={Three} alt=" " class="img-fluid" />
                    <h4>Complete Registration</h4>
                    <p>
                      Click 'register' and your wallet will re-open. Only after
                      the 2nd transaction is confirmed you'll know if you got
                      the name.
                    </p>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Container>
        </section>
        <section className="usBetter">
          <Container>
            <Grid item xs={12}>
              <h1>{searchDomainTitle?.usbetterTitle}</h1>
            </Grid>
            <Grid style={{ display: 'flex', flexWrap: 'wrap' }}>
              {usBetters &&
                usBetters.map(usBetter => (
                  <Grid container item xl={3} lg={3} md={3} sm={12} xs={12}>
                    <div className="usBetterDetail">
                      <img
                        src={
                          REACT_APP_STRAPI_API_URL +
                          usBetter?.attributes?.Image?.data[0]?.attributes.url
                        }
                        alt=" "
                        class="img-fluid"
                      />
                      <h2>{usBetter.attributes.name}</h2>
                      <p>{usBetter.attributes.content}</p>
                    </div>
                  </Grid>
                ))}
            </Grid>
          </Container>
        </section>
      </div>
    </>
  )
}

export default SearchThirdStep
